export const fetchPeriodFinancialSheetTree = data => ({
  type: "FETCH_PERIOD_FINANCIAL_SHEET_TREE",
  payload: data
});

export const initPeriodFinancialSheetTree = () => ({
  type: "INIT_FINANCIAL_SHEET_TREE"
});

export const initFinancialSortBy = () => ({
  type: "INIT_FINANCIAL_SORT_BY"
});

export const setFinancialSortBy = sortBy => ({
  type: "SET_FINANCIAL_SORT_BY",
  sortBy
});

export const setClientType = clientType => {
  return {
    type: "SET_CLIENT_TYPE",
    clientType
  };
};

export const setClientCRMType = clientCRMTypes => {
  return {
    type: "SET_CLIENT_CRM_TYPE",
    clientCRMTypes
  };
};

export const setClientCRMGroup = clientCRMGroup => {
  return {
    type: "SET_CLIENT_CRM_GROUP",
    clientCRMGroup
  };
};

export const setClientsDeletedState = clientState => {
  return {
    type: "SET_CLIENT_STATE",
    clientState
  };
};

export const setIsEntityClientsState = entityState => {
  return {
    type: "SET_ENTITY_CLIENT_STATE",
    entityState
  };
};

export const setFinancialSheetTreeSearchWord = searchWord => {
  return {
    type: "SET_PERIOD_FINANCIAL_SHEET_TREE_SEARCH_WORD",
    searchWord
  };
};

export const setFinancialSheetTreeBudgetTab = selectedTab => {
  return {
    type: "SET_PERIOD_FINANCIAL_SHEET_BUDGET_TAB",
    selectedTab
  };
};

export const exportPeriodFinancialSheetTree = data => ({
  type: "EXPORT_FINANCIAL_SHEET",
  payload: data
});

export const setImportFinancialModal = visible => ({
  type: "SET_IMPORT_FINANCIAL_MODAL",
  visible
});

export const setImportAttachment = importAttachment => ({
  type: "SET_IMPORT_ATTACHMENT",
  importAttachment
});

export const importFinancialSheet = resp => ({
  type: "IMPORT_FINANCIAL_SHEET",
  payload: resp
});

export const setImportedYear = year => ({
  type: "SET_FINANCIAL_IMPORTED_YEAR",
  year
});

export const setRole = role => {
  return {
    type: "SET_ROLE",
    role
  };
};

export const setFinancialSheetStartPaginationState = (startPage, pageSize) => {
  return {
    type: "SET_FINANCIAL_SHEET_PAGINATION_STATE",
    startPage,
    pageSize
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/financial-sheet.js